module.exports = __webpack_public_path__ + "img/marker_yellow.ae7757f0.svg";